const enumMeaureSurvey = {
  weight: 7,
  height: 8,
  bmi: 9,
  fev1Male: 56,
  fev1Female: 57,
  fvc: 58,
  'fev1/fvc': 59,
  rightEye: 60,
  leftEye: 67,
  doctorMeeting: 64,
  doctorPredibetesMeeting: 64
};

export default enumMeaureSurvey;
